import { useState } from "react";
import { toast } from "sonner";
import axios from "../../axios";

export const UsePrizes = () => {
  const [loading, setLoading] = useState(false);
  const [submittingPrizes, setSubmittingPrizes] = useState(false);
  const [prizes, setPrizes] = useState([]);
  const [storeAudiencePrizes, setStoreAudiencePrizes] = useState([]);

  const getPrizes = async (token) => {
    setLoading(true);
    try {
      const res = await axios.get("/audiences/arena/prizes", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        setLoading(false);
        setPrizes(res?.data?.data);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data.message);
    }
  };
  const storePrizes = async (id, storeAudiencePrizes, trial_count) => {
    setSubmittingPrizes(true);
    try {
      const res = await axios.post(
        `/audiences/spin-the-wheel/${id}/spin`,
        JSON.stringify({
          prizes: storeAudiencePrizes,
          trial_count,
        })
      );
      if (res.status === 200) {
        setSubmittingPrizes(false);
        return true;
      }
      return false;
    } catch (err) {
      setSubmittingPrizes(false);
      toast.error(err.response.data.message);
      return false;
    }
  };

  return {
    getPrizes,
    prizes,
    setPrizes,
    loading,
    setLoading,
    storeAudiencePrizes,
    setStoreAudiencePrizes,
    submittingPrizes,
    setSubmittingPrizes,
    storePrizes,
  };
};
